import axios from "axios";
import { BACKEND } from "../config/configEnvs";
import { toast } from "react-toastify";

const HandleUpdateSelect = async (field, newValue, targetID, route, setElements = null) => {
  try {
    
    await axios.put(`${BACKEND}/api/${route}/${targetID}`, {
      [field]: newValue,
    });

    if (setElements) {
      setElements((prevData) =>
        prevData.map((e) =>
          e.id === targetID
            ? {
                ...e,
                [field]: newValue,
              }
            : e
        )
      );
    }

    // toast.success("Dato actualizado con éxito!")
  } catch (e) {
    toast.error("Error al actualizar el dato: " + e);
  }
}

export default HandleUpdateSelect